// ============================================================
//  KAJU BAUPLANER – ZENTRALE KONFIGURATION
//  Datei: assets/kaju-bauplaner-config.js
//
//  HIER alles einstellen:
//  - Steintypen (IDs, Labels, Bilder)
//  - Shopify Variant-Mapping (für ATC + Cart-Erkennung)
//  - Set-Stücklisten
//  - Bauwerk-Datenbank
//
//  Quelle für Bauwerk-Daten: projekte/kaju-bauplaner/bauwerke-daten.md
//  Quelle für Set-Daten:     projekte/kaju-bauplaner/sets-daten.md
// ============================================================

window.KAJU_BAUPLANER_CONFIG = {

  // ----------------------------------------------------------
  // Steintypen – alle bekannten Steinarten
  // bildUrl: leer = Platzhalter-Farbe im UI
  // ----------------------------------------------------------
  steintypen: [
    { id: 'bogenstein_gelb',    label: 'Gelber Bogenstein',    farbe: '#f1c953', bildUrl: '' },
    { id: 'bogenstein_orange',  label: 'Orangener Bogenstein', farbe: '#f39200', bildUrl: '' },
    { id: 'bogenstein_gruen',   label: 'Grüner Bogenstein',    farbe: '#6cac53', bildUrl: '' },
    { id: 'wuerfel_2er',        label: 'Roter Würfel (2er)',   farbe: '#a93015', bildUrl: '' },
    { id: 'wuerfel_3er',        label: 'Roter Würfel (3er)',   farbe: '#8b1e0a', bildUrl: '' },
    { id: 'wuerfel_5er',        label: 'Roter Würfel (5er)',   farbe: '#6b0f00', bildUrl: '' },
    { id: 'weiche_orange',      label: 'Orangene Weiche',      farbe: '#e07b00', bildUrl: '' },
    { id: 'weiche_gelb',        label: 'Gelbe Weiche',         farbe: '#d4aa00', bildUrl: '' },
    { id: 'bogenstapler',       label: 'Bogenstapler',         farbe: '#c8a040', bildUrl: '' },
    { id: 'sockelstein',        label: 'Sockelstein',          farbe: '#888888', bildUrl: '' },
    { id: 'quader',             label: 'Quader',               farbe: '#999999', bildUrl: '' },
    { id: 'saeulen_basis',      label: 'Säulenbasis',          farbe: '#aaaaaa', bildUrl: '' },
    { id: 'saeulen_schaft',     label: 'Säulenschaft',         farbe: '#bbbbbb', bildUrl: '' },
    { id: 'saeulen_kapitel',    label: 'Säulenkapitell',       farbe: '#cccccc', bildUrl: '' },
  ],

  // ----------------------------------------------------------
  // Variant-Mapping – Shopify Varianten-IDs der Einzelsteine
  // null = Platzhalter (noch nicht befüllt)
  // ----------------------------------------------------------
  variantMapping: {
    bogenstein_gelb:   '52457709928787',
    bogenstein_orange: '52457709961555',
    bogenstein_gruen:  '52457709994323',
    wuerfel_2er:       '53255893483859',
    wuerfel_3er:       '53282164605267',
    wuerfel_5er:       '53282169848147',
    weiche_orange:     '52457710190931',
    weiche_gelb:       '53282163229011',
    bogenstapler:      '52457710125395',
    sockelstein:       '53282172731731',
    quader:            '53282168111443',
    saeulen_basis:     '53282178728275',
    saeulen_schaft:    '53282178531667',
    saeulen_kapitel:   '53282177384787',
  },

  // ----------------------------------------------------------
  // Sets – Stücklisten
  // Reihenfolge = Anzeigereihenfolge im Inventar-Panel
  // ----------------------------------------------------------
  sets: [
    {
      id:    'starter_set',
      label: 'Grundset',
      steine: {
        bogenstein_gelb:   12,
        bogenstein_orange: 12,
        bogenstein_gruen:   6,
        weiche_orange:      2,
        wuerfel_2er:        8,
        wuerfel_3er:        2,
      }
    },
    {
      id:    'murmel_bundle',
      label: 'Bogenwelten-Bundle',
      steine: {
        bogenstein_gelb:   12,
        bogenstein_orange: 12,
        bogenstein_gruen:   6,
        weiche_orange:      2,
        wuerfel_2er:        8,
        wuerfel_3er:        2,
      }
    },
    {
      id:    'entdecker_bogenstapler',
      label: 'Entdecker-Set Bogenstapler',
      steine: {
        bogenstein_gelb:   7,
        bogenstein_orange: 2,
        wuerfel_2er:       4,
        bogenstapler:      3,
      }
    },
    {
      id:    'entdecker_brunnen',
      label: 'Entdecker-Set Brunnen',
      steine: {
        // TODO: Stückliste noch offen
      }
    },
    {
      id:    'entdecker_giraffe',
      label: 'Entdecker-Set Giraffe',
      steine: {
        // TODO: Stückliste noch offen
      }
    },
    {
      id:    'entdecker_raupenbande',
      label: 'Entdecker-Set Raupenbande',
      steine: {
        // TODO: Stückliste noch offen
      }
    },
  ],

  // ----------------------------------------------------------
  // Bauwerke – Datenbank
  // Quelle: projekte/kaju-bauplaner/bauwerke-daten.md
  // kategorie: 'legebild' | 'bogen' | 'skulptur'
  // schwierigkeit: 1 | 2 | 3
  // ----------------------------------------------------------
  // === BAUWERKE START (managed by dashboard) ===
  bauwerke: [
    {
      id:            "mini-rundbogen-3-gelbe",
      name:          "Mini-Rundbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-mini-rundbogen-3-gelbe.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, wuerfel_2er: 2 },
      ringbuecher:   [1],
    },
    {
      id:            "kleiner-parabelbogen",
      name:          "Kleiner Parabelbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kleiner-parabelbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_orange: 2, wuerfel_2er: 2 },
      ringbuecher:   [1],
    },
    {
      id:            "kleiner-korbbogen",
      name:          "Kleiner Korbbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kleiner-korbbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_orange: 2, wuerfel_2er: 2 },
      ringbuecher:   [1],
    },
    {
      id:            "kleiner-spezialbogen",
      name:          "Kleiner Spezialbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kleiner-spezialbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 1, bogenstein_gruen: 2, bogenstein_gelb: 2, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "bunter-korbbogen",
      name:          "Bunter Korbbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bunter-korbbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_orange: 1, wuerfel_2er: 2, bogenstein_gruen: 2 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr2",
      name:          "Parabelbogen Nr.2",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr2.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 4, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr3",
      name:          "Parabelbogen Nr. 3",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr3.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_gruen: 4, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr4",
      name:          "Parabelbogen Nr. 4",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr4.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 2, bogenstein_gruen: 2, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "rundbogen-6o",
      name:          "Rundbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-rundbogen-6o.jpg",
      pdfUrl:        '',
      steine:        { wuerfel_2er: 2, bogenstein_orange: 6 },
      ringbuecher:   [1],
    },
    {
      id:            "parabelbogen-nr4v2",
      name:          "Parabelbogen Nr.4 Variante 2",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr4v2.jpg",
      pdfUrl:        '',
      steine:        { wuerfel_5er: 2, bogenstein_orange: 2, bogenstein_gelb: 1, bogenstein_gruen: 4 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr4v3",
      name:          "Parabelbogen Nr.4 Variante 3",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr4v3.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 2, wuerfel_2er: 2, bogenstein_gruen: 4 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr5",
      name:          "Parabelbogen Nr.5",
      kategorie:     "bogen",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr5.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_gruen: 8, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr6",
      name:          "Parabelbogen Nr.6",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr6.jpg",
      pdfUrl:        '',
      steine:        { wuerfel_2er: 2, bogenstein_gruen: 8, bogenstein_orange: 2 },
      ringbuecher:   [],
    },
    {
      id:            "parabelbogen-nr7",
      name:          "Parabelbogen Nr.7",
      kategorie:     "bogen",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-parabelbogen-nr7.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 10, bogenstein_orange: 1, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "korbbogen",
      name:          "Korbbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-korbbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_gruen: 4, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "spitzbogenv3",
      name:          "Spitzbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-spitzbogenv3.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 6, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "kleiner-tudorbogen",
      name:          "Kleiner Tudorbogen",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kleiner-tudorbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_gruen: 2, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "bunter-tudorbogen",
      name:          "Bunter Tudorbogen",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bunter-tudorbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_gruen: 2, bogenstein_orange: 2, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "tudorbogen",
      name:          "Tudorbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-tudorbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 4, wuerfel_2er: 3, bogenstein_gruen: 2 },
      ringbuecher:   [],
    },
    {
      id:            "grosser-tudorbogen",
      name:          "Großer Tudorbogen",
      kategorie:     "bogen",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-grosser-tudorbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 6, bogenstein_orange: 2, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "skulptur-01",
      name:          "Skulptur 01",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-skulptur-01.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, wuerfel_2er: 4, bogenstein_orange: 2 },
      ringbuecher:   [],
    },
    {
      id:            "bogenbogenv1",
      name:          "BogenBogen",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bogenbogenv1.jpg",
      pdfUrl:        '',
      steine:        { weiche_orange: 2, bogenstein_orange: 8, wuerfel_2er: 2, bogenstein_gelb: 1 },
      ringbuecher:   [],
    },
    {
      id:            "flamme2",
      name:          "Kleine Flamme",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-flamme2.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 6, wuerfel_2er: 7, quader: 1 },
      ringbuecher:   [],
    },
    {
      id:            "teufelsbogen",
      name:          "Teufelsbogen",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-teufelsbogen.jpg",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 4, wuerfel_2er: 4, weiche_orange: 2, bogenstein_gruen: 6 },
      ringbuecher:   [],
    },
    {
      id:            "baum",
      name:          "Baum",
      kategorie:     "legebild",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-baum.jpg",
      pdfUrl:        '',
      steine:        { wuerfel_5er: 3, weiche_orange: 3, bogenstein_gruen: 11, bogenstein_orange: 8 },
      ringbuecher:   [],
    },
    {
      id:            "taube",
      name:          "Taube",
      kategorie:     "legebild",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-taube.jpg",
      pdfUrl:        '',
      steine:        { weiche_orange: 2, bogenstein_orange: 7, bogenstein_gelb: 7, wuerfel_2er: 2 },
      ringbuecher:   [1],
    },
    {
      id:            "kleines-doppeltor-mit-zwiebel",
      name:          "Zwiebeltor",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kleines-doppeltor-mit-zwiebel.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 8, wuerfel_2er: 4, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "flammenturm",
      name:          "Flammenturm",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-flammenturm.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 6, weiche_orange: 7, wuerfel_2er: 2, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "kreisportal-mit-stabilisierung",
      name:          "Kreisportal mit Stabilisierung",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kreisportal-mit-stabilisierung.jpg",
      pdfUrl:        '',
      steine:        { weiche_orange: 28, bogenstein_orange: 12, wuerfel_2er: 6 },
      ringbuecher:   [],
    },
    {
      id:            "kuessende-pferde",
      name:          "Küssende Pferde",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kuessende-pferde.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 4, bogenstein_orange: 4, wuerfel_2er: 4, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "kreisportal-auf-scheitel",
      name:          "Kreisportal auf Scheitel",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kreisportal-auf-scheitel.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 12, weiche_orange: 11, sockelstein: 3 },
      ringbuecher:   [],
    },
    {
      id:            "herz",
      name:          "Herz",
      kategorie:     "legebild",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-herz.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_orange: 3, wuerfel_2er: 1 },
      ringbuecher:   [],
    },
    {
      id:            "kuerbisgesicht",
      name:          "Kürbisgesicht",
      kategorie:     "legebild",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kuerbisgesicht.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 10, bogenstein_orange: 2, bogenstein_gruen: 4, wuerfel_2er: 5 },
      ringbuecher:   [],
    },
    {
      id:            "vierpass-rosette",
      name:          "Vierpass-Rosette",
      kategorie:     "legebild",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-vierpass-rosette.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 16, wuerfel_2er: 5 },
      ringbuecher:   [],
    },
    {
      id:            "gelbes-ringportal",
      name:          "Gelbes Ringportal",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-gelbes-ringportal.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 10, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "kleines-fenstertor",
      name:          "Kleines Fenstertor",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-kleines-fenstertor.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 4, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "goldbogen",
      name:          "Goldbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-goldbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 4, bogenstein_gelb: 3, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "orangenschlaufe",
      name:          "Orangenschlaufe",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-orangenschlaufe.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 15, bogenstein_gelb: 1, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "birne",
      name:          "Birne",
      kategorie:     "legebild",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-birne.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 5, bogenstein_orange: 5, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "herzschlaufe",
      name:          "Herzschlaufe",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-herzschlaufe.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 8, bogenstein_gruen: 6, bogenstein_gelb: 6, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "bogenpaar",
      name:          "Bogenpaar",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bogenpaar.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_orange: 6, bogenstein_gruen: 2, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "doppelrundbogen",
      name:          "Doppelrundbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-doppelrundbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 12, bogenstein_gelb: 1, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "doppelaugenturm",
      name:          "Doppelaugenturm",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-doppelaugenturm.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 10, bogenstein_gelb: 1, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "bogenkette",
      name:          "Bogenkette",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bogenkette.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, bogenstein_gruen: 4, bogenstein_orange: 3, wuerfel_2er: 6 },
      ringbuecher:   [],
    },
    {
      id:            "rakete",
      name:          "Rakete",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-rakete.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 4, bogenstein_gruen: 6, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "zwillingsspitze",
      name:          "Zwillingsspitze",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-zwillingsspitze.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 6, bogenstein_orange: 3, wuerfel_2er: 5 },
      ringbuecher:   [],
    },
    {
      id:            "vierbeiniger-turm",
      name:          "Vierbeiniger Turm",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-vierbeiniger-turm.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_orange: 6, bogenstein_gruen: 4, wuerfel_2er: 5 },
      ringbuecher:   [],
    },
    {
      id:            "vierarmranke",
      name:          "Vierarmranke",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-vierarmranke.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 8, bogenstein_gruen: 2, bogenstein_orange: 5, wuerfel_2er: 5 },
      ringbuecher:   [],
    },
    {
      id:            "wurzelbaum",
      name:          "Wurzelbaum",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-wurzelbaum.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_gruen: 2, bogenstein_orange: 5, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "doppelschlange",
      name:          "Doppelschlange",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-doppelschlange.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_orange: 6, bogenstein_gruen: 2, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "hufeisenbogen",
      name:          "Hufeisenbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-hufeisenbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_orange: 2, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "schluesselloch",
      name:          "Schlüsselloch",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-schluesselloch.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_orange: 2, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "dreifachbogen",
      name:          "Dreifachbogen",
      kategorie:     "bogen",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-dreifachbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_orange: 8, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "brille",
      name:          "Brille",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-brille.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 12, bogenstein_orange: 6, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "doppelring",
      name:          "Doppelring",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-doppelring.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 14, bogenstein_orange: 3, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "bunter-spitzbogen",
      name:          "Bunter Spitzbogen",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bunter-spitzbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 2, bogenstein_gelb: 2, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "windrad",
      name:          "Windrad",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-windrad.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 8, bogenstein_gelb: 4, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "schneckenpfad",
      name:          "Schneckenpfad",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-schneckenpfad.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 13, bogenstein_orange: 8, bogenstein_gruen: 6, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "sprosse",
      name:          "Sprosse",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-sprosse.webp",
      pdfUrl:        '',
      steine:        { wuerfel_2er: 3, bogenstein_gelb: 5, bogenstein_orange: 1 },
      ringbuecher:   [],
    },
    {
      id:            "lupenstaender",
      name:          "Lupenständer",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-lupenstaender.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 4, bogenstein_gelb: 1, bogenstein_gruen: 2, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "regenbogenportal",
      name:          "Regenbogenportal",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-regenbogenportal.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 8, bogenstein_gelb: 1, bogenstein_gruen: 4, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "bogen-im-bogen",
      name:          "Bogen im Bogen",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bogen-im-bogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 4, bogenstein_gelb: 8, bogenstein_orange: 2, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "bogenzelt",
      name:          "Bogenzelt",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bogenzelt.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gruen: 8, bogenstein_gelb: 5, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "rosettenportal",
      name:          "Rosettenportal",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-rosettenportal.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 16, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "rundbogen-gelb-gruen",
      name:          "Rundbogen Gelb-Grün",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-rundbogen-gelb-gruen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_gruen: 4, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "rundbogen-gruen-spitze",
      name:          "Rundbogen mit grüner Spitze",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-rundbogen-gruen-spitze.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_gruen: 4, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "rundbogen-gold-gelb",
      name:          "Rundbogen Gold-Gelb",
      kategorie:     "bogen",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-rundbogen-gold-gelb.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 2, bogenstein_gelb: 2, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "astgabel",
      name:          "Astgabel",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-astgabel.webp",
      pdfUrl:        '',
      steine:        { wuerfel_2er: 8, bogenstein_orange: 2, bogenstein_gruen: 8 },
      ringbuecher:   [],
    },
    {
      id:            "bergkette",
      name:          "Bergkette",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-bergkette.webp",
      pdfUrl:        '',
      steine:        { wuerfel_2er: 6, bogenstein_gruen: 6, bogenstein_orange: 4, bogenstein_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "wellenkette",
      name:          "Wellenkette",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-wellenkette.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 10, bogenstein_orange: 6, wuerfel_2er: 6 },
      ringbuecher:   [],
    },
    {
      id:            "augenportal",
      name:          "Augenportal",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-augenportal.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 6, weiche_gelb: 4, bogenstein_gruen: 4, wuerfel_2er: 2 },
      ringbuecher:   [],
    },
    {
      id:            "wendelsaeule",
      name:          "Wendelsäule",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-wendelsaeule.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_gruen: 3, bogenstein_orange: 6, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "knotenpfad",
      name:          "Knotenpfad",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-knotenpfad.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 8, bogenstein_orange: 6, bogenstein_gruen: 4, wuerfel_2er: 7 },
      ringbuecher:   [],
    },
    {
      id:            "doppelspirale",
      name:          "Doppelspirale",
      kategorie:     "skulptur",
      schwierigkeit: 3,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-doppelspirale.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 8, bogenstein_orange: 6, bogenstein_gruen: 6, wuerfel_2er: 8 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-bogenstapler-portal",
      name:          "Bogenstapler-Portal",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-bogenstapler-portal.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstapler: 3, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-kleiner-drache",
      name:          "Kleiner Drache",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-kleiner-drache.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 1, bogenstapler: 3, wuerfel_2er: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-doppelbogen-mit-spitze",
      name:          "Doppelbogen mit Spitze",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-doppelbogen-mit-spitze.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 2, bogenstapler: 3, wuerfel_2er: 3 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-dreifachbogen",
      name:          "Dreifachbogen Bogenstapler",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-dreifachbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstapler: 3, wuerfel_2er: 4 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-raupen-bogenpaar",
      name:          "Raupen-Bogenpaar",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-raupen-bogenpaar.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, bogenstein_orange: 4, bogenstein_gruen: 4, wuerfel_2er: 1, sockelstein: 2, quader: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-raupenportal",
      name:          "Raupenportal",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-raupenportal.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, bogenstein_orange: 4, bogenstein_gruen: 4, sockelstein: 1, quader: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-dromedar",
      name:          "Dromedar",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-dromedar.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, bogenstein_orange: 3, bogenstein_gruen: 3, wuerfel_2er: 1, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-doppelraupe",
      name:          "Doppelraupe",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-doppelraupe.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, bogenstein_orange: 4, bogenstein_gruen: 4, wuerfel_2er: 1, sockelstein: 1, quader: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-raupenbruecke",
      name:          "Raupenbrücke",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-raupenbruecke.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 3, bogenstein_orange: 4, bogenstein_gruen: 4, wuerfel_2er: 1, sockelstein: 1, quader: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-giraffe",
      name:          "Giraffe",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-giraffe.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 4, bogenstein_gruen: 4, weiche_orange: 3, wuerfel_2er: 1, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-giraffenkopf",
      name:          "Giraffenkopf",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-giraffenkopf.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_gruen: 2, weiche_orange: 3, wuerfel_2er: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-zipfelzwerg",
      name:          "Zipfelzwerg",
      kategorie:     "skulptur",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-zipfelzwerg.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 2, weiche_orange: 1, wuerfel_2er: 1, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-spitzbogen",
      name:          "Giraffen-Spitzbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-spitzbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 6, bogenstein_gruen: 2, wuerfel_2er: 1, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-teufelsbruecke",
      name:          "Teufelsbrücke",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-teufelsbruecke.webp",
      pdfUrl:        '',
      steine:        { bogenstein_orange: 4, bogenstein_gruen: 4, weiche_orange: 2, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-weichenturm",
      name:          "Weichenturm",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-weichenturm.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 4, bogenstein_gruen: 4, weiche_orange: 2, wuerfel_2er: 1, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-giraffenbogen",
      name:          "Giraffenbogen",
      kategorie:     "bogen",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-giraffenbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 1, bogenstein_orange: 4, weiche_orange: 3, sockelstein: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-ringbogen",
      name:          "Brunnen-Ringbogen",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-ringbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 4, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-t-stein-schlange",
      name:          "T-Stein-Schlange",
      kategorie:     "legebild",
      schwierigkeit: 1,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-t-stein-schlange.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 2, bogenstein_orange: 1, weiche_gelb: 1 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-wellenbogen",
      name:          "Brunnen-Wellenbogen",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-wellenbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 4, wuerfel_2er: 2, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-h-tor",
      name:          "Brunnen-H-Tor",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-h-tor.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 4, wuerfel_2er: 2, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-bruecke-ring",
      name:          "Brunnen-Brücke mit Ring",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-bruecke-ring.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 2, wuerfel_2er: 2, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-fluegeltor",
      name:          "Brunnen-Flügeltor",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-fluegeltor.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 4, wuerfel_2er: 2, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-bogenstern",
      name:          "Brunnen-Bogenstern",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-bogenstern.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 7, bogenstein_orange: 4, wuerfel_2er: 2, weiche_gelb: 2 },
      ringbuecher:   [],
    },
    {
      id:            "entdecker-brunnen-kreativbogen",
      name:          "Brunnen-Kreativbogen",
      kategorie:     "skulptur",
      schwierigkeit: 2,
      bildUrl:       "https://cdn.shopify.com/s/files/1/0822/1733/7171/t/16/assets/bauplaner-entdecker-brunnen-kreativbogen.webp",
      pdfUrl:        '',
      steine:        { bogenstein_gelb: 6, bogenstein_orange: 3, wuerfel_2er: 2, weiche_gelb: 2 },
      ringbuecher:   [],
    },
  ],
  // === BAUWERKE END ===

}; // ende KAJU_BAUPLANER_CONFIG
